import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce } from "../utils/functions";

const $window = $(window);
const $body = $("body");
const $header = $(".header");
const $hamburger = $(".header__hamburger");
const $search = $(".search");
const $searchTrigger = $(".search__trigger");
const $searchClose = $(".search__close");
const $searchWrapper = $(".search__wrapper");
const $searchInput = $(".search__input");
const $bannerSearchInput = $(".banner__search-input");
const $searchContent = $(".search__content");
const $navMenuTitle = $(".navigation-menu__title");

const toggleSearch = (filter) => {
  if ($search.hasClass("search--active")) {
    hideSearch(filter, true);
  } else {
    showSearch();
  }
};

const showSearch = () => {
  $search.addClass("search--active");
  $searchTrigger.addClass("search__trigger--active");
  $searchInput.val("");
  $searchInput.trigger("focus");
  $header.addClass("header--search-active");
};

const hideSearch = (filter, force = false) => {
  if ($search.hasClass("search--active")) {
    if (force === true) {
      $searchInput.val("");
    }
    if (!$searchInput.val()) {
      filter.page = 1;
      filter.search = $searchInput.val();
      reRenderSearch(filter);
      $search.removeClass("search--active");
      $searchTrigger.removeClass("search__trigger--active");
      $searchTrigger.trigger("focus");
      $header.removeClass("header--search-active");
    }
  }
};

const bindPagination = (filter) => {
  $searchContent.off("click", ".pagination__item");
  $searchContent.on("click", ".pagination__item", function () {
    filter.page = $(this).data("page");
    reRenderSearch(filter, true);
  });
};

const bindSearch = (filter) => {
  $searchInput.on(
    "input",
    debounce(function () {
      filter.search = $searchInput.val();
      reRenderSearch(filter);
    })
  );
};

const reRenderSearch = async (filter, scrollTop = false) => {
  return;
  if (filter.search === "") {
    filter.page = 1;
    $searchContent.html("");
  } else {
    const data = await getSearchItems(filter);
    $searchContent.html(data.html);
    bindPagination(filter);

    if (scrollTop === true) {
      smoothscroll(0, 0, 500, $search);
    }
  }
};

const getSearchItems = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/vuvh/v1/search/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const filter = {
  page: 1,
  search: $searchInput.val(),
  lang: $search.data("lang"),
};

$window.on(
  "resize:width",
  debounce(function () {
    hideSearch(filter);
  }, true)
);
$searchTrigger.on("click", function (event) {
  event.stopPropagation();

  if ($searchTrigger.hasClass("search__trigger--homepage")) {
    smoothscroll(0);
    $bannerSearchInput.trigger("focus");
  } else {
    toggleSearch(filter);
  }
});
$bannerSearchInput.on({
  focusin: function () {
    $searchTrigger.addClass("search__trigger--active");
  },
  focusout: function () {
    $searchTrigger.removeClass("search__trigger--active");
  },
});
$searchWrapper.on("click", function (event) {
  event.stopPropagation();
});
$body.on("click", function () {
  hideSearch(filter);
});
$hamburger.on("click", function () {
  hideSearch(filter, true);
});
$searchClose.on("click", function () {
  hideSearch(filter, true);
});
$navMenuTitle.on("click", function () {
  hideSearch(filter, true);
});
$search.on("keydown", function (e) {
  if ($search.hasClass("search--active")) {
    if (e.key === "Tab") {
      e.preventDefault();
    } else if (e.key === "Escape") {
      hideSearch(filter, true);
    }
  }
});
bindSearch(filter);
